<section *ngIf="contract && contract.CONTRATO && contract.BOX" class="contract-page">
  <header class="contract-header">
    <div class="contract-header-main">
      <button
        mat-icon-button
        type="button"
        class="back-button"
        (click)="returnToDashboard()"
        matTooltip="Voltar para contratos"
        aria-label="Voltar para contratos"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div>
        <h1>Detalhe do contrato {{ contract.CONTRATO.GEN_CONTRATO }} (Box {{ contract.BOX.DESCRICAO_BOX }})</h1>
        <p>{{ statusSummaryText }}</p>
      </div>
    </div>

    <div class="contract-header-actions">
<!--      <button mat-stroked-button type="button" (click)="emitSecondCopy()">-->
<!--        <mat-icon>description</mat-icon>-->
<!--        Emitir 2ª via do contrato-->
<!--      </button>-->

<!--      <button mat-stroked-button type="button" (click)="openPaymentHistory()">-->
<!--        <mat-icon>history</mat-icon>-->
<!--        Histórico de pagamentos-->
<!--      </button>-->

<!--      <button-->
<!--        mat-flat-button-->
<!--        color="primary"-->
<!--        type="button"-->
<!--        [matMenuTriggerFor]="actionsMenu"-->
<!--        aria-label="Abrir ações do contrato"-->
<!--      >-->
<!--        Ações-->
<!--        <mat-icon>expand_more</mat-icon>-->
<!--      </button>-->
    </div>
  </header>

  <section class="contract-summary-bar">
    <article class="summary-highlight">
      <div class="summary-box-illustration" aria-hidden="true">
        <img src="assets/images/cubo-box.png" alt="" class="box-image">
      </div>
      <div>
        <span class="summary-label">Box contratado</span>
        <strong>{{ contract.BOX.DESCRICAO_BOX }}</strong>
        <div class="summary-subline">
          <span class="summary-chip">{{ boxSizeLabel }}</span>
          <span>Unidade {{ contract.CONTRATO.DESCRICAO_LOJA}}</span>
        </div>
      </div>
    </article>

    <article class="summary-metric">
      <span class="summary-label">Situação do contrato</span>
      <strong [class.summary-danger]="contract.CONTRATO.INADIMPLENCIA">{{ contractStatusLabel }}</strong>
      <span class="metric-note">{{ statusSummaryText }}</span>
    </article>

    <article class="summary-metric">
      <span class="summary-label">Início da locação</span>
      <strong>{{ formatDate(contract.CONTRATO.DATA_LOCACAO) }}</strong>
      <span class="metric-note">{{ contractAgeText }}</span>
    </article>

    <article class="summary-metric">
      <span class="summary-label">Vencimento</span>
      <strong>Dia {{ displayValue(contract.CONTRATO.DIA_VENCIMENTO) }}</strong>
      <span class="metric-note">Todo mês</span>
    </article>

    <article class="summary-metric">
      <span class="summary-label">Próxima fatura</span>
      <strong>{{ nextInvoice ? formatDate(nextInvoice.DATA_VENCIMENTO) : '—' }}</strong>
      <span class="metric-note">{{ nextInvoice ? formatCurrency(nextInvoice.VALOR_TOTAL) : formatCurrency(contract.CONTRATO.VALOR_MENSALIDADE) }}</span>
    </article>
  </section>

  <mat-tab-group class="contract-tabs" animationDuration="0ms" [(selectedIndex)]="selectedTabIndex">
    <mat-tab label="Resumo">
      <div class="summary-grid">
        <mat-card class="content-card box-card">
          <mat-card-content>
            <div class="card-title">
              <mat-icon>inventory_2</mat-icon>
              <span>Box e medidas</span>
            </div>
            <div class="box-card-body">
              <div class="box-drawing" aria-hidden="true">
                <img src="assets/images/cubo-box.png" alt="" class="box-image">
                <span class="measure measure-height">{{ displayValue(contract.BOX.ALTURA) }} m</span>
                <span class="measure measure-width">{{ displayValue(contract.BOX.LARGURA) }} m</span>
                <span class="measure measure-depth">{{ displayValue(contract.BOX.COMPRIMENTO || contract.BOX.PROFUNDIDADE) }} m</span>
              </div>

              <div class="detail-list">
                <div class="detail-row">
                  <span>Descrição</span>
                  <strong>{{ contract.BOX.DESCRICAO_BOX }}</strong>
                </div>
                <div class="detail-row">
                  <span>Tamanho</span>
                  <strong>{{ boxSizeLabel }}</strong>
                </div>
                <div class="detail-row">
                  <span>Dimensões</span>
                  <strong>{{ boxDimensionLabel }}</strong>
                </div>
                <div class="detail-row">
                  <span>Área</span>
                  <strong>{{ displayMeasure(contract.BOX.AREA, 'm²') }}</strong>
                </div>
                <div class="detail-row">
                  <span>Volume</span>
                  <strong>{{ displayMeasure(contract.BOX.VOLUME, 'm³') }}</strong>
                </div>
<!--                <div class="detail-row">-->
<!--                  <span>Valor base do box</span>-->
<!--                  <strong>{{ formatCurrency(contract.CONTRATO.VALOR_BASE) }}</strong>-->
<!--                </div>-->
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="content-card">
          <mat-card-content>
            <div class="card-title">
              <mat-icon>payments</mat-icon>
              <span>Valores e condições</span>
            </div>
            <div class="detail-list">
              <div class="detail-row"><span>Mensalidade atual</span><strong>{{ formatCurrency(contract.CONTRATO.VALOR_MENSALIDADE) }}</strong></div>
<!--              <div class="detail-row"><span>Valor base</span><strong>{{ formatCurrency(contract.CONTRATO.VALOR_BASE) }}</strong></div>-->
              <div class="detail-row"><span>Forma de pagamento</span><strong>{{ paymentMethodLabel }}</strong></div>
              <div class="detail-row"><span>Dia de vencimento</span><strong>Dia {{ displayValue(contract.CONTRATO.DIA_VENCIMENTO) }} de cada mês</strong></div>
              <div class="detail-row"><span>Multa</span><strong>{{ displayValue('Conforme contrato') }}</strong></div>
              <div class="detail-row"><span>Juros de mora</span><strong>{{ displayValue('Conforme contrato') }}</strong></div>
              <div class="detail-row"><span>Índice de reajuste</span><strong>{{ displayValue('Conforme contrato') }}</strong></div>
              <div class="detail-row"><span>Próximo reajuste</span><strong>{{ displayValue('Conforme contrato') }}</strong></div>
            </div>
            <div class="inline-note">
              <mat-icon>info</mat-icon>
              <span>Valores e encargos podem seguir as regras previstas no contrato assinado.</span>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="content-card">
          <mat-card-content>
            <div class="card-title">
              <mat-icon>person</mat-icon>
              <span>Dados do cliente</span>
            </div>
            <div class="status-pill" [class.status-pill-warning]="contract.CONTRATO.INADIMPLENCIA">
              {{ contract.CONTRATO.INADIMPLENCIA ? 'Cliente com pendência' : 'Cliente ativo' }}
            </div>
            <div class="detail-list">
              <div class="detail-row"><span>Nome / Razão social</span><strong>{{ displayValue(contract.CADASTRO_GERAL.NOME) }}</strong></div>
              <div class="detail-row"><span>Tipo de pessoa</span><strong>{{ personTypeLabel }}</strong></div>
              <div class="detail-row"><span>Documento</span><strong>{{ documentLabel }}</strong></div>
              <div class="detail-row"><span>E-mail</span><strong>{{ displayValue(contract.CADASTRO_GERAL.EMAIL) }}</strong></div>
              <div class="detail-row"><span>Celular</span><strong>{{ displayValue(contract.CADASTRO_GERAL.CELULAR) }}</strong></div>
              <div class="detail-row"><span>Tipo de cadastro</span><strong>{{ displayValue(contract.CADASTRO_GERAL.DESCRICAO_TIPO_CADASTRO) }}</strong></div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="content-card">
          <mat-card-content>
            <div class="card-title">
              <mat-icon>event</mat-icon>
              <span>Prazos importantes</span>
            </div>
            <div class="detail-list">
              <div class="detail-row"><span>Início da locação</span><strong>{{ formatDate(contract.CONTRATO.DATA_LOCACAO) }}</strong></div>
              <div class="detail-row"><span>Vencimento (todo mês)</span><strong>Dia {{ displayValue(contract.CONTRATO.DIA_VENCIMENTO) }}</strong></div>
              <div class="detail-row"><span>Próxima fatura</span><strong>{{ nextInvoice ? formatDate(nextInvoice.DATA_VENCIMENTO) : '—' }}</strong></div>
              <div class="detail-row"><span>Último pagamento</span><strong>{{ lastPaidInvoice ? formatDate(lastPaidInvoice.DATA_PAGAMENTO) : '—' }}</strong></div>
<!--              <div class="detail-row"><span>Data para finalizar</span><strong>{{ formatDate(contract.CONTRATO.FINALIZAR_CONTRATO_DATA || contract.CONTRATO.DATA_FINALIZAR) }}</strong></div>-->
            </div>
            <div class="warning-note">
              <mat-icon>warning_amber</mat-icon>
              <span>Mantenha seus pagamentos em dia para evitar multa e juros.</span>
            </div>
          </mat-card-content>
        </mat-card>

<!--        <mat-card class="content-card">-->
<!--          <mat-card-content>-->
<!--            <div class="card-title">-->
<!--              <mat-icon>monitoring</mat-icon>-->
<!--              <span>Status financeiro</span>-->
<!--            </div>-->
<!--            <div class="finance-status-grid">-->
<!--              <div>-->
<!--                <span class="metric-label">Situação</span>-->
<!--                <strong [class.success-text]="!contract.CONTRATO.INADIMPLENCIA" [class.danger-text]="contract.CONTRATO.INADIMPLENCIA">-->
<!--                  {{ contractStatusLabel }}-->
<!--                </strong>-->
<!--                <span class="metric-note">{{ statusSummaryText }}</span>-->
<!--              </div>-->
<!--              <div>-->
<!--                <span class="metric-label">Inadimplência</span>-->
<!--                <strong>{{ totalOverdueCount }}</strong>-->
<!--                <span class="metric-note">{{ totalOverdueCount ? 'Fatura(s) vencida(s)' : 'Nenhuma pendência' }}</span>-->
<!--              </div>-->
<!--              <div>-->
<!--                <span class="metric-label">Último pagamento</span>-->
<!--                <strong>{{ lastPaidInvoice ? formatDate(lastPaidInvoice.DATA_PAGAMENTO) : '—' }}</strong>-->
<!--                <span class="metric-note">{{ lastPaidInvoice ? formatCurrency(lastPaidInvoice.VALOR_TOTAL) : 'Sem pagamentos recentes' }}</span>-->
<!--              </div>-->
<!--              <div>-->
<!--                <span class="metric-label">Próximo vencimento</span>-->
<!--                <strong>{{ nextInvoice ? formatDate(nextInvoice.DATA_VENCIMENTO) : '—' }}</strong>-->
<!--                <span class="metric-note">{{ nextInvoice ? formatCurrency(nextInvoice.VALOR_TOTAL) : 'Sem faturas em aberto' }}</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </mat-card-content>-->
<!--        </mat-card>-->

        <mat-card class="content-card content-card-wide">
          <mat-card-content>
            <div class="card-title card-title-between">
              <div>
                <mat-icon>account_balance_wallet</mat-icon>
                <span>Resumo financeiro</span>
              </div>
              <button mat-stroked-button type="button" (click)="openAllInvoices()">Ver todas as faturas</button>
            </div>
            <div class="kpi-grid">
              <div class="kpi-item">
                <span>Mensalidade atual</span>
                <strong>{{ formatCurrency(contract.CONTRATO.VALOR_MENSALIDADE) }}</strong>
              </div>
<!--              <div class="kpi-item">-->
<!--                <span>Valor base</span>-->
<!--                <strong>{{ formatCurrency(contract.CONTRATO.VALOR_BASE) }}</strong>-->
<!--              </div>-->
              <div class="kpi-item">
                <span>Total pago</span>
                <strong>{{ formatCurrency(totalPaidLast12Months) }}</strong>
                <small>Últimos 12 meses</small>
              </div>
              <div class="kpi-item">
                <span>Total a vencer</span>
                <strong class="success-text">{{ formatCurrency(totalOpenAmount) }}</strong>
              </div>
              <div class="kpi-item">
                <span>Total vencido</span>
                <strong class="danger-text">{{ formatCurrency(totalOverdueAmount) }}</strong>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

<!--        <mat-card class="content-card">-->
<!--          <mat-card-content>-->
<!--            <div class="card-title">-->
<!--              <mat-icon>storefront</mat-icon>-->
<!--              <span>Unidade e origem</span>-->
<!--            </div>-->
<!--            <div class="detail-list">-->
<!--              <div class="detail-row"><span>Unidade / Loja</span><strong>{{ displayValue(contract.CONTRATO.DESCRICAO_LOJA || contract.BOX.DESCRICAO_LOJA) }}</strong></div>-->
<!--&lt;!&ndash;              <div class="detail-row"><span>Código do box</span><strong>{{ displayValue(contract.BOX.GEN_BOX) }}</strong></div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="detail-row"><span>Campanha</span><strong>—</strong></div>&ndash;&gt;-->
<!--              <div class="detail-row"><span>Situação geral</span><strong>{{ contractStatusLabel }}</strong></div>-->
<!--&lt;!&ndash;              <div class="detail-row"><span>Incluído em</span><strong>{{ formatDate(contract.CONTRATO.DATA_ENTRADA || contract.CONTRATO.DATA_LOCACAO) }}</strong></div>&ndash;&gt;-->
<!--&lt;!&ndash;              <div class="detail-row"><span>Observação do contrato</span><strong>{{ displayValue(contract.CONTRATO.DESCRICAO) }}</strong></div>&ndash;&gt;-->
<!--            </div>-->
<!--          </mat-card-content>-->
<!--        </mat-card>-->

        <mat-card class="content-card">
          <mat-card-content>
            <div class="card-title">
              <mat-icon>info</mat-icon>
              <span>Informações adicionais</span>
            </div>
            <div class="detail-list">
              <div class="detail-row"><span>Boleto com senha</span><strong>{{ hasBoleto ? 'Sim' : 'Não' }}</strong></div>
              <div class="detail-row"><span>Recorrência cadastrada</span><strong>{{ hasCreditCard ? 'Sim' : 'Não' }}</strong></div>
              <div class="detail-row"><span>Inadimplente</span><strong>{{ contract.CONTRATO.INADIMPLENCIA ? 'Acompanhar pendências' : 'Não' }}</strong></div>
<!--              <div class="detail-row"><span>Finalizar contrato</span><strong>{{ formatDate(contract.CONTRATO.FINALIZAR_CONTRATO_DATA || contract.CONTRATO.DATA_FINALIZAR) }}</strong></div>-->
<!--              <div class="detail-row"><span>Conta</span><strong>{{ displayValue(contract.CADASTRO_GERAL.CODIGO_CADASTRO_GERAL) }}</strong></div>-->
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="content-card">
          <mat-card-content>
            <div class="card-title">
              <mat-icon>vpn_key</mat-icon>
              <span>Acesso ao box</span>
            </div>
            <div class="detail-list">
              <div class="detail-row"><span>Total de controles</span><strong>{{ totalAccessUsers }}</strong></div>
              <div class="detail-row"><span>Status geral</span><strong>{{ accessStatusLabel }}</strong></div>
              <div class="detail-row"><span>Nome no display</span><strong>{{ displayValue(contract.CADASTRO_GERAL.CA_NOME_DISPLAY) }}</strong></div>
              <div class="detail-row"><span>Código principal</span><strong>{{ displayValue(contract.CADASTRO_GERAL.CA_CODIGO_ACESSO) }}</strong></div>
              <div class="detail-row"><span>Último acesso</span><strong>{{ lastAccessChangeDate }}</strong></div>
            </div>
            <div class="card-actions-inline">
              <button mat-stroked-button type="button" (click)="focusAccessTab()">Ver acessos</button>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>

<!--    <mat-tab label="Dados do contrato">-->
<!--      <mat-card class="content-card tab-card">-->
<!--        <mat-card-content>-->
<!--          <form [formGroup]="form">-->
<!--            <div class="row g-3">-->
<!--              <div class="col-12 col-md-4">-->
<!--                <mat-form-field class="full" appearance="outline">-->
<!--                  <mat-label>Unidade</mat-label>-->
<!--                  <input matInput type="text" formControlName="DESCRICAO_LOJA" readonly>-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--              <div class="col-12 col-md-4">-->
<!--                <mat-form-field class="full" appearance="outline">-->
<!--                  <mat-label>Data de locação</mat-label>-->
<!--                  <input matInput type="text" formControlName="DATA_LOCACAO" readonly>-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--              <div class="col-12 col-md-4">-->
<!--                <mat-form-field class="full" appearance="outline">-->
<!--                  <mat-label>Mensalidade</mat-label>-->
<!--                  <input matInput currencyMask [options]="defaultNgxCurrency" formControlName="VALOR_MENSALIDADE" [readonly]="true">-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--              <div class="col-12 col-md-4">-->
<!--                <mat-form-field class="full" appearance="outline">-->
<!--                  <mat-label>Valor base</mat-label>-->
<!--                  <input matInput currencyMask [options]="defaultNgxCurrency" formControlName="VALOR_BASE" [readonly]="true">-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--              <div class="col-12 col-md-4">-->
<!--                <mat-form-field class="full" appearance="outline">-->
<!--                  <mat-label>Data prevista de término</mat-label>-->
<!--                  <input matInput type="text" formControlName="DATA_PREVISAO_TERMINO" readonly>-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--              <div class="col-12 col-md-4">-->
<!--                <mat-form-field class="full" appearance="outline">-->
<!--                  <mat-label>Data de finalização</mat-label>-->
<!--                  <input matInput type="text" formControlName="FINALIZAR_CONTRATO_DATA" readonly>-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--            </div>-->
<!--          </form>-->
<!--        </mat-card-content>-->
<!--      </mat-card>-->
<!--    </mat-tab>-->

    <mat-tab label="Financeiro">
      <mat-card class="content-card tab-card">
        <mat-card-content>
          <app-table
            [dataSource]="dataSourceFinancial"
            [displayedColumns]="fieldsFatura"
            defaultEmptyResultMessage="Nenhuma cobrança encontrada"
            defaultRoute="/principal/faturas/"
          ></app-table>
        </mat-card-content>
      </mat-card>
    </mat-tab>

<!--    <mat-tab label="Faturas">-->
<!--      <mat-card class="content-card tab-card">-->
<!--        <mat-card-content>-->
<!--          <div class="placeholder-panel">-->
<!--            <mat-icon>receipt_long</mat-icon>-->
<!--            <h3>Central de faturas</h3>-->
<!--            <p>Visualize as cobranças do contrato e abra o detalhe de cada fatura quando precisar.</p>-->
<!--            <button mat-flat-button color="primary" type="button" (click)="openAllInvoices()">Ver todas as faturas</button>-->
<!--          </div>-->
<!--        </mat-card-content>-->
<!--      </mat-card>-->
<!--    </mat-tab>-->

    <mat-tab label="Acessos">
      <mat-card class="content-card tab-card">
        <mat-card-content>
          <mat-tab-group>
            <mat-tab label="Acesso principal">
              <form [formGroup]="formUsuarioPrincipal" class="access-form">
                <div class="row g-3">
                  <div class="col-12 col-md-6">
                    <mat-form-field class="full" appearance="outline">
                      <mat-label>Nome no display</mat-label>
                      <input matInput maxlength="20" placeholder="Digite o nome" type="text" required formControlName="CA_NOME_DISPLAY">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-md-6">
                    <mat-form-field class="full" appearance="outline">
                      <mat-label>Código de acesso</mat-label>
                      <input matInput maxlength="10" inputmode="numeric" placeholder="Digite o código de acesso" type="text" required formControlName="CA_CODIGO_ACESSO">
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button mat-flat-button color="primary" type="button" [disabled]="formUsuarioPrincipal.invalid" (click)="saveMainUserData()">Gravar</button>
                  </div>
                </div>
              </form>
            </mat-tab>
            <mat-tab label="Acessos secundários">
              <div class="table-container" *ngIf="dataSourceBoxAccessUsers.data.length > 0; else semAcessosSecundarios">
                <table mat-table [dataSource]="dataSourceBoxAccessUsers" class="access-table">
                  <ng-container matColumnDef="CPF">
                    <th mat-header-cell *matHeaderCellDef>CPF</th>
                    <td mat-cell *matCellDef="let element">{{ element.CPF | mask: '000.000.000-00' }}</td>
                  </ng-container>
                  <ng-container matColumnDef="NOME">
                    <th mat-header-cell *matHeaderCellDef>Nome</th>
                    <td mat-cell *matCellDef="let element">{{ element.NOME }}</td>
                  </ng-container>
                  <ng-container matColumnDef="MENSAGEM_ACESSO_LIBERADO">
                    <th mat-header-cell *matHeaderCellDef>Liberado</th>
                    <td mat-cell *matCellDef="let element">{{ element.ACESSO_LIBERADO === 'S' ? 'Sim' : 'Não' }}</td>
                  </ng-container>
                  <ng-container matColumnDef="NOME_DISPLAY">
                    <th mat-header-cell *matHeaderCellDef>Nome no display</th>
                    <td mat-cell *matCellDef="let element">{{ element.NOME_DISPLAY }}</td>
                  </ng-container>
                  <ng-container matColumnDef="CODIGO_ACESSO">
                    <th mat-header-cell *matHeaderCellDef>Código de acesso</th>
                    <td mat-cell *matCellDef="let element">{{ element.CODIGO_ACESSO }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsBoxAccessUsers"></tr>
                  <tr
                    (click)="loadDataBoxAccessUser(row.GEN_CONTRATO_CONTROLE_ACESSO, contract.CONTRATO.GEN_CONTRATO)"
                    (keydown.enter)="loadDataBoxAccessUser(row.GEN_CONTRATO_CONTROLE_ACESSO, contract.CONTRATO.GEN_CONTRATO)"
                    class="tr-box-access-user"
                    mat-row
                    tabindex="0"
                    *matRowDef="let row; columns: displayedColumnsBoxAccessUsers;"
                  ></tr>
                </table>
              </div>
              <ng-template #semAcessosSecundarios>
                <div class="placeholder-panel compact">
                  <mat-icon>info</mat-icon>
                  <h3>Nenhum registro encontrado</h3>
                  <p>Você ainda não possui acessos secundários cadastrados para este box.</p>
                </div>
              </ng-template>

              <div class="tab-actions">
                <button (click)="includeNewBoxUser(contract.CONTRATO.GEN_CONTRATO)" color="primary" mat-flat-button type="button">Incluir</button>
              </div>
            </mat-tab>
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </mat-tab>

<!--    <mat-tab label="Documentos">-->
<!--      <mat-card class="content-card tab-card">-->
<!--        <mat-card-content>-->
<!--          <div class="placeholder-panel compact">-->
<!--            <mat-icon>folder_open</mat-icon>-->
<!--            <h3>Documentos do contrato</h3>-->
<!--            <p>Esta área pode concentrar contrato assinado, anexos e comprovantes em uma próxima etapa.</p>-->
<!--          </div>-->
<!--        </mat-card-content>-->
<!--      </mat-card>-->
<!--    </mat-tab>-->

<!--    <mat-tab label="Histórico">-->
<!--      <mat-card class="content-card tab-card">-->
<!--        <mat-card-content>-->
<!--          <div class="placeholder-panel compact">-->
<!--            <mat-icon>timeline</mat-icon>-->
<!--            <h3>Histórico do contrato</h3>-->
<!--            <p>Use o histórico de pagamentos para acompanhar cobranças já liquidadas e movimentações financeiras.</p>-->
<!--            <button mat-stroked-button type="button" (click)="openPaymentHistory()">Abrir histórico de pagamentos</button>-->
<!--          </div>-->
<!--        </mat-card-content>-->
<!--      </mat-card>-->
<!--    </mat-tab>-->
  </mat-tab-group>
</section>

<!--<mat-menu #actionsMenu="matMenu">-->
<!--  <button mat-menu-item (click)="openAllInvoices()">-->
<!--    <mat-icon>receipt_long</mat-icon>-->
<!--    <span>Ver faturas</span>-->
<!--  </button>-->
<!--  <button mat-menu-item (click)="focusAccessTab()">-->
<!--    <mat-icon>vpn_key</mat-icon>-->
<!--    <span>Gerenciar acessos</span>-->
<!--  </button>-->
<!--  <button mat-menu-item (click)="includeNewBoxUser(contract.CONTRATO.GEN_CONTRATO.toString())">-->
<!--    <mat-icon>person_add</mat-icon>-->
<!--    <span>Adicionar acesso secundário</span>-->
<!--  </button>-->
<!--</mat-menu>-->
